import { Component } from '@angular/core';
import { FrCarouselConfig } from 'fr-carousel';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent {

  // images = [1036, 1040, 484, 169, 413].map((n) => `https://picsum.photos/id/${n}/1200/400`);

  images = ['assets/img/carousel/cnc.jpg',
            'assets/img/carousel/cnc2.jpg',
            'assets/img/carousel/cortile.jpg',
            'assets/img/carousel/motore.jpg',
            'assets/img/carousel/pannelli_solari.jpg',
            'assets/img/carousel/pannelli_solari2.jpg',
            'assets/img/carousel/pannelli_solari3.jpg'];

  constructor(config: FrCarouselConfig) {
    // customize default values of carousels used by this component tree
    config.interval = 8000;
    config.animationDuration = 2000;
    config.showNavigationArrows = false;
    config.pauseOnHover = false;
  }


}
